import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class AreaMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
  
  getList(data?: any) {
    return this.http.post(Path.AREA.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.AREA.GET_DETAIL, params);
  }
    
  insert(data?: any) {
    return this.http.post(Path.AREA.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_AREA_MAINTENACE, data);
  }
}
